import React from 'react'
import UsersAudit from './UsersAudit'

const UsersPermissionsAndAudit = () => {
    return (
        <UsersAudit
            locationData={{ role: 'A' }}
            locationId=''
            type='list'
        />
    )
}

export default UsersPermissionsAndAudit